import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleDelete) => {
  return [
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Role",
    },
    {
      dataIndex: "total_employee",
      key: "total_employee",
      title: "Jumlah Akun",
    },
    {
      dataIndex: "access",
      key: "access",
      title: "Akses",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "7%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_role}
            yes={
              <Link
                to={{
                  pathname: `edit_role/${record.id}`,
                  state: {
                    name: record.name,
                    description: record.description,
                  },
                }}
              >
                <div className="mr-2">
                  <BiEditAlt
                    style={{
                      fontSize: 24,
                      color: "#F5CB58",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </Link>
            }
          />
          <CanAccess
            role={AuthorizationList.delete_role}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
